import { type ClassNameValue, extendTailwindMerge } from 'tailwind-merge'
import { omit } from 'es-toolkit'
import type { ClassNameProp } from '~/types/elementsUi'
import type { SlotClassReplacer } from '@nuxt/ui'

export const twMerge = extendTailwindMerge<'column' | 'offset'>({
  prefix: '',
  extend: {
    classGroups: {
      column: [
        'full',
        'half',
        'one-third',
        'two-thirds',
        'one-quarter',
        'three-quarters',
        'one-fifth',
        'two-fifths',
        'three-fifths',
        'four-fifths',
        'one-sixth',
        'five-sixths'
      ],
      offset: [
        'offset-half',
        'offset-one-third',
        'offset-two-thirds',
        'offset-one-quarter',
        'offset-three-quarters',
        'offset-one-fifth',
        'offset-two-fifths',
        'offset-three-fifths',
        'offset-four-fifths',
        'offset-one-sixth',
        'offset-five-sixths',
        'offset-one-twelfth',
        'offset-five-twelfths',
        'offset-seven-twelfths',
        'offset-eleven-twelfths'
      ]
    }
  }
})

export function nuxtUiMerge<
  T extends Record<string, ClassNameValue | SlotClassReplacer | undefined>
>(s: T | undefined, d: T | undefined): T | undefined {
  const source = s as Record<string, ClassNameProp | undefined>
  const defaults = d as Record<string, ClassNameProp | undefined>

  if (!defaults) {
    return source as T
  }

  if (!source) {
    return defaults as T
  }

  const duplicateKeys = Object.keys(defaults)
  const result: Record<string, ClassNameValue> = omit(source, duplicateKeys)

  for (const key of duplicateKeys) {
    result[key] = twMerge(defaults[key], source[key])
  }

  return result as T
}

export function tw(
  strings: TemplateStringsArray,
  ...values: (string | number)[]
): string {
  let result = ''

  // Standard string interpolation algorithm
  for (let i = 0; i < strings.length; i++) {
    result += strings[i] // Add the literal string part

    // If there's a corresponding interpolated value for this gap
    if (i < values.length) {
      result += String(values[i]) // Add the interpolated value
    }
  }

  return result.trim() // Trim any leading/trailing whitespace
}
